import {
  rankWith,
  isNumberControl,
  isStringControl,
  isObjectArrayControl,
  isPrimitiveArrayControl,
  formatIs,
  and,
  optionIs,
  uiTypeIs,
  or,
  scopeEndsWith,
  type Tester,
} from '@jsonforms/core';

// CurrencyControl: matches number fields with currency-related names or explicit option
const isCurrencyScope: Tester = or(
  scopeEndsWith('Rent'),
  scopeEndsWith('rent'),
  scopeEndsWith('Deposit'),
  scopeEndsWith('deposit'),
);

export const currencyTester = rankWith(
  5,
  or(
    and(isNumberControl, isCurrencyScope),
    and(isNumberControl, optionIs('format', 'currency')),
  ),
);

// PhoneControl: matches string fields with phone in the name or explicit option
const isPhoneScope: Tester = or(
  scopeEndsWith('Phone'),
  scopeEndsWith('phone'),
);

export const phoneTester = rankWith(
  5,
  or(
    and(isStringControl, isPhoneScope),
    and(isStringControl, optionIs('format', 'phone')),
  ),
);

// DateControl: matches any string with format: "date" in schema
export const dateTester = rankWith(6, and(isStringControl, formatIs('date')));

// SectionLabelRenderer: matches Label ui schema elements
export const sectionLabelTester = rankWith(5, uiTypeIs('Label'));

// CardArrayRenderer: matches all object and primitive arrays (rank 5 > default rank 3)
export const cardArrayTester = rankWith(
  5,
  or(isObjectArrayControl, isPrimitiveArrayControl),
);
